import type { DistributorUserPathParams } from '@si/types';
import { del } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

export function useRemoveDistributorUser() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (params: DistributorUserPathParams) =>
      del({
        url: `/distributors/${params.distributorId}/users/${params.userId}`,
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.getDistributors }),
  });

  const removeDistributorUser = useCallback(
    (params: DistributorUserPathParams) => mutate(params),
    [mutate]
  );

  return {
    removeDistributorUser,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
